import { render } from "./NotificationConfig.vue?vue&type=template&id=19e98a98"
import script from "./NotificationConfig.vue?vue&type=script&lang=js"
export * from "./NotificationConfig.vue?vue&type=script&lang=js"

import "./NotificationConfig.vue?vue&type=style&index=0&id=19e98a98&lang=css"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__